// local stoarge keys
export const LS_KEY = {
  AUTH_INFO: "AUTH_INFO",
  CLOSE_SIGNIN_TOOLTIP: "CLOSE_SIGNIN_TOOLTIP",
  LOGIN_SERVER: "LOGIN_SERVER",
}

// session storage keys
export const SS_KEY = {
  PATH_BEFORE_SIGNIN: "PATH_BEFORE_SIGNIN",
  SELECTED_PLAN_BEFORE_SIGNIN: "SELECTED_PLAN_BEFORE_SIGNIN"
}

export interface ISelectedPlanBeforeSignin {
  selected_at: number; // timestamp in milliseconds
  type: "personal" | "business";
  interval: "monthly" | "yearly";
}

export const LINKS = {
  LITE_MSP: {
    OFFICIAL: 'https://my.firewalla.net',
    DEV: 'https://t1.dd.firewalla.net',
  }
}